import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../auth/AuthContext'
import { apiFetch } from '../api/client'
import type { BillingPlansResponse } from '../api/types'

// useBillingPlans fetches the plan + Amp-pack catalog from the
// authenticated, read-only GET /v1/billing/plans. The catalog is the
// single source of plan metadata and Stripe price ids the Billing page
// renders (D8: no VITE_STRIPE_PRICE_* env dependency).
//
// Near-static, so cached like useMe (staleTime 60s) and gated on an
// authenticated user — mirrors useAccountUsage's shape.
export function useBillingPlans() {
  const { idTokenProvider, user } = useAuth()
  return useQuery({
    queryKey: ['billing-plans'],
    queryFn: ({ signal }) =>
      apiFetch<BillingPlansResponse>('/v1/billing/plans', idTokenProvider, { signal }),
    enabled: !!user,
    staleTime: 60_000,
  })
}
